import React from 'react';
import '../../styles/onboardingFlow/mobileLogoCard/mobileLogoSlide4.scss';
import window1 from '../../assets/onboarding/slides/slide4/window1.png';
import window2 from '../../assets/onboarding/slides/slide4/window2.svg';
import window3 from '../../assets/onboarding/slides/slide4/window3.svg';
import window4 from '../../assets/onboarding/slides/slide4/window4.svg';

const MobileLogoSlide4: React.FC = () => {
  return (
    <div className='mobileLogoSlide4'>
      <div className='mobileLogoSlide4__content'>
        <div className='mobileLogoSlide4__windows'>
          <div className='mobileLogoSlide4__window mobileLogoSlide4__window--1'>
            <img src={window1} alt='Alert Window 1' />
          </div>
          <div className='mobileLogoSlide4__window mobileLogoSlide4__window--2'>
            <img src={window2} alt='Alert Window 2' />
          </div>
          <div className='mobileLogoSlide4__window mobileLogoSlide4__window--3'>
            <img src={window3} alt='Alert Window 3' />
          </div>
          <div className='mobileLogoSlide4__window mobileLogoSlide4__window--4'>
            <img src={window4} alt='Alert Window 4' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileLogoSlide4;
